import {useState} from 'react'
import {toAbsoluteUrl} from '../../_metronic/helpers'
import {Link} from 'react-router-dom'
import upload from '../../_metronic/assets/images/upload.png'
// import {IProfileDetails, profileDetailsInitValues as initialValues} from '../EditMapTypes'
// import * as Yup from 'yup'
// import {useFormik} from 'formik'

// const profileDetailsSchema = Yup.object().shape({
//   fName: Yup.string().required('First name is required'),
//   lName: Yup.string().required('Last name is required'),
//   company: Yup.string().required('Company name is required'),
//   contactPhone: Yup.string().required('Contact phone is required'),
//   companySite: Yup.string().required('Company site is required'),
//   country: Yup.string().required('Country is required'),
//   language: Yup.string().required('Language is required'),
//   timeZone: Yup.string().required('Time zone is required'),
//   currency: Yup.string().required('Currency is required'),
// })

// const EditMapDetail: React.FC = () => {
//   const [data, setData] = useState < IProfileDetails > initialValues
//   const updateData = (fieldsToUpdate: Partial<IProfileDetails>): void => {
//     const updatedData = Object.assign(data, fieldsToUpdate)
//     setData(updatedData)

//    const formik =
//     useFormik <
//     IProfileDetails >
//     {
//       initialValues,
//       validationSchema: profileDetailsSchema,
//       onSubmit: (values) => {
//         setLoading(true)
//         setTimeout(() => {
//           values.communications.email = data.communications.email
//           values.communications.phone = data.communications.phone
//           values.allowMarketing = data.allowMarketing
//           const updatedData = Object.assign(data, values)
//           setData(updatedData)
//           setLoading(false)
//         }, 1000)
//       },
//     }

const EditMapDetail = () => {
  const [loading, setLoading] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log('worked')
  }

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_profile_details'
        aria-expanded='true'
        aria-controls='kt_account_profile_details'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Map Edit Page</h3>
        </div>
      </div>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>Map Name</label>

              <div className='col-lg-8'>
                <div className='row'>
                  <div className='col-lg-6 fv-row'>
                    <input
                      type='text'
                      className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                      placeholder='Map Name'
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label required fw-bold fs-6'>
                Map Description
              </label>

              <div className='col-lg-8 fv-row'>
                <textarea className='form-control' id='exampleFormControlTextarea1' rows={3}>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Similique dicta, nisi
                  esse mollitia dolore et. Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Similique dicta, nisi esse mollitia dolore et. Lorem ipsum dolor sit amet
                  consectetur adipisicing elit. Similique dicta, nisi esse mollitia dolore et.
                </textarea>
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Map Capacity</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='tel'
                  className='form-control form-control-lg form-control-solid'
                  placeholder='Map Capacity'
                />
              </div>
            </div>
            <div className='row mb-7'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Map Url</span>
              </label>

              <div className='col-lg-8 d-flex align-items-center'>
                <input
                  className='form-control form-control-lg form-control-solid'
                  type='text'
                  placeholder='Map Url Link'
                />
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Map Events Type</span>
              </label>

              <div className='col-lg-8 fv-row'>
                <div
                  style={{
                    display: 'flex',
                    width: '100%',
                    gap: '10px',
                    alignItems: 'center',
                  }}
                >
                  <input type='checkbox' id='' name='' value='' defaultChecked={true} />
                  <label htmlFor=''>Concert</label>
                  <input type='checkbox' id='' name='' value='' defaultChecked={true} />
                  <label htmlFor=''>Meeting</label>
                  <input type='checkbox' id='' name='' value='' defaultChecked={true} />
                  <label htmlFor=''>Party</label>
                </div>
              </div>
            </div>
            <div className='row mb-7'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>
                <span className='required'>Map Images</span>
              </label>

              <div className='col-lg-8 map_cards'>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
                <span className='map_item'>
                  <img className='map_img' src={upload} alt='' />
                </span>
              </div>
            </div>

            {/*    <div className='row mb-0'>
              <label className='col-lg-4 col-form-label fw-bold fs-6'>Accept Details</label>

             <div className='col-lg-8 d-flex align-items-center'>
                <div className='form-check form-check-solid form-switch fv-row'>
                  <input
                    className='form-check-input w-45px h-30px'
                    type='checkbox'
                    id='allowmarketing'
                  />
                  <label className='form-check-label'></label>
                </div>
              </div> 
            </div>*/}
          </div>

          <div className='card-footer d-flex justify-content-end py-6 px-9'>
            <button type='submit' className='btn btn-primary' disabled={loading}>
              {!loading && 'Save Changes'}
              {loading && (
                <span className='indicator-progress' style={{display: 'block'}}>
                  Please wait...{' '}
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            <Link to='/map/tutorial-island'>
              <button className='btn btn-secondary ms-2'>Go Back</button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  )
}

export {EditMapDetail}
